var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldNotificationSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16.48c0 .14-.01.28-.02.41-.01.12-.02.23-.04.35-.01.12-.03.24-.05.35-.35 2.42-1.89 3.95-4.3 4.3-.11.02-.23.04-.35.05-.12.02-.23.03-.35.04-.13.01-.27.02-.41.02H7.52c-.14 0-.28-.01-.41-.02-.12-.01-.23-.02-.35-.04-.12-.01-.24-.03-.35-.05-2.41-.35-3.95-1.88-4.3-4.3-.02-.11-.04-.23-.05-.35-.02-.12-.03-.23-.04-.35-.01-.13-.02-.27-.02-.41V8.52c0-.14.01-.28.02-.41.01-.12.02-.23.04-.35.01-.12.03-.24.05-.35.35-2.42 1.89-3.95 4.3-4.3.11-.02.23-.04.35-.05.12-.02.23-.03.35-.04.13-.01.27-.02.41-.02h6.08a1 1 0 0 1 .98 1.2c0 .02-.01.04-.01.06-.02.1-.03.2-.05.31-.04.42-.02.87.07 1.33.03.12.05.22.09.33.08.33.21.64.38.93.06.12.14.24.21.35.33.48.74.89 1.22 1.22.11.07.23.15.35.21.29.17.6.3.93.38.11.04.21.06.33.09.46.09.91.11 1.33.07.11-.02.21-.03.31-.05.02 0 .04-.01.06-.01a1 1 0 0 1 1.2.98v6.08z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldNotificationSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-notification-square.543f7a7bdfd098eb9c27c8a0dd226639.svg";
export { ForwardRef as ReactComponent };